import { forwardRef, useEffect } from "react";
import { motion } from "framer-motion";
import { EMBEDDED_FILTER_LABEL_CLASS } from "../../embedded-filter/constants";

const COMPACT_LABEL_CLASS =
  "mb-0.5 block text-[10px] font-semibold uppercase tracking-wide text-gray-800";

const FilterField = forwardRef(function FilterField(
  {
    id,
    label,
    children,
    focusedFieldId,
    onFocusClear,
    className = "",
    labelVariant = "compact",
  },
  ref,
) {
  const labelClassName =
    labelVariant === "embedded" ? EMBEDDED_FILTER_LABEL_CLASS : COMPACT_LABEL_CLASS;
  const isHighlighted = focusedFieldId === id;

  useEffect(() => {
    if (!isHighlighted || !ref?.current) return undefined;
    ref.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    const timer = setTimeout(() => {
      onFocusClear?.();
    }, 650);
    return () => clearTimeout(timer);
  }, [isHighlighted, ref, onFocusClear]);

  return (
    <motion.div
      ref={ref}
      id={id}
      className={[
        "rounded border border-transparent py-0.5 transition-colors",
        isHighlighted ? "border-gray-300 bg-gray-50 atlas-filter-field-highlight" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label ? (
        <label
          htmlFor={`${id}-control`}
          className={labelClassName}
        >
          {label}
        </label>
      ) : null}
      {children}
    </motion.div>
  );
});

export default FilterField;
